import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  ShieldCheck,
  Ticket,
  Bell,
  Buildings,
  ArrowRight,
} from '@phosphor-icons/react'

import { useLang } from '../../context/LangContext'
import { useSite } from '../../context/SiteContext'
import { useAuth } from '../../context/AuthContext'
import LangToggle from '../../components/LangToggle/LangToggle'

import icon_logo from '../../assets/images/logo.png'

export default function AuthPage() {
  const { t } = useLang()
  const { site } = useSite()
  const { login } = useAuth()
  const navigate = useNavigate()

  const [email, setEmail]       = useState('')
  const [password, setPassword] = useState('')
  const [error, setError]       = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    const ok = login(email, password)
    if (ok) {
      navigate('/')
    } else {
      setError('Invalid credentials. Please try again.')
    }
  }

  return (
    <div className="public-page auth-page">
      <div className="public-page__topbar auth-topbar">
        <div className="public-page__brand">
          <div className="sidebar__logo-icon"><img src={icon_logo} height={40} alt="Permata Suri logo" /></div>
          <span className="public-page__brand-name">
            {site?.name ?? 'HelpDesk'}
          </span>
        </div>

        <div className="auth-topbar__actions">
          <LangToggle />
        </div>
      </div>

      <div className="auth-shell">
        <section className="auth-welcome-card">
          <div className="auth-welcome-card__top">
            <div className="auth-welcome-card__logo"><img src={icon_logo} height={60} alt="Permata Suri logo" /></div>
            <div>
              <h1>{site?.name ?? 'HelpDesk'}</h1>
              <p>{t('portalLabel')}</p>
            </div>
          </div>

          <div className="auth-welcome-card__body">
            <span className="auth-welcome-card__eyebrow">
              <ShieldCheck size={16} /> Secure member access
            </span>
            <h2>Welcome back</h2>
            <p>
              Sign in to submit tickets, track your requests, and receive updates from the support team.
            </p>
          </div>

          <div className="auth-feature-grid">
            <div>
              <Ticket size={20} />
              <span>Submit tickets</span>
            </div>
            <div>
              <Bell size={20} />
              <span>Get updates</span>
            </div>
            <div>
              <Buildings size={20} />
              <span>Site access</span>
            </div>
          </div>
        </section>

        <form className="auth-form-card" onSubmit={handleSubmit}>
          <div className="auth-form-card__header">
            <h2>{t('signIn')}</h2>
            <p>{t('sharedLogin')}</p>
          </div>

          {error && (
            <div className="auth-card__error">{error}</div>
          )}

          <div className="form-group">
            <label className="form-label">{t('emailLabel')}</label>
            <input
              className="form-input"
              type="email"
              placeholder="you@organisation.gov.my"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label">{t('passwordLabel')}</label>
            <input
              className="form-input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="auth-card__row">
            <label className="auth-card__remember">
              <input type="checkbox" defaultChecked />
              <span>{t('rememberMe')}</span>
            </label>
            <span className="link" style={{ fontSize: 12 }}>{t('forgotPass')}</span>
          </div>

          <button className="btn btn--primary btn--full auth-submit-btn" type="submit">
            {t('signIn')} <ArrowRight size={16} />
          </button>
        </form>
      </div>
    </div>
  )
}
